import React from 'react';
import "./VCBContainer.sass";
import VCButton from './VCButton/VCButton';
// @ts-ignore
import { LocalizationContext } from "react-localize";
import { ReservationType } from 'Interfaces/GetReservations';
type Props = {
    setActive: any
    activeBtn: string
}

class VCBContainer extends React.Component<Props>{
    constructor(props: Props) {
        super(props);
        this.state = {
            activeBtn: props.activeBtn
        }
    }
   
    render(){
        const { localize } = this.context;

        const btnContents =[
            {
                copy: localize("static.content.view-res-page-upcoming"),
                route:"",
                key: ReservationType.UPCOMING
                
            },
            {
                copy:localize("static.content.view-res-page-past"),
                route:"",
                key: ReservationType.PAST
            },
            {
                copy:localize("static.content.view-res-page-cancelled"),
                route:"",
                key: ReservationType.CANCELED
            }
        ]

        return(
            <div className="btn-wrp">
                {
                    btnContents.map((contents) =>{
                        return <VCButton key={contents.key} contents={contents} setActive={this.props.setActive} active={this.props.activeBtn}/>
                    })
                }               
            </div>
        )
    }    
}
VCBContainer.contextType = LocalizationContext;
export default VCBContainer;